module.exports = __webpack_public_path__ + "static/media/layout.ac1464da.svg";